// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import colors from '../../styled-components/palette';

const Wrapper = styled.div`
  width: 100%;
  background-color: ${theme.Scoreboards.wrapperBackground};
  overflow: hidden;
  display: flex;
  align-items: baseline;
  justify-content: center;
  color: white;
  font-size: 1.1em;
`;

const Team = styled.div`
  display: inline-block;
  padding: 0 0.3em;
  color: ${colors.bluegrey350};
`;

const Dash = styled.div`
  display: inline-block;
  padding: 0 0.3em;
`;

const Score = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 1.2em;

  margin: 0 0.3em 0.1em 0.3em;

  ${({ $grey }) => (!$grey ? `color: ${colors.yellowwinamax450};` : `color: ${colors.neutralgrey150};`)};
`;

type ScoreboardMultimatchProps = {
  className?: string;
  homeScore: number;
  awayScore: number;
  isEnded: boolean;
};

const ScoreboardMultimatch = ({ className, homeScore, awayScore, isEnded }: ScoreboardMultimatchProps): Node => {
  return (
    <Wrapper className={className} $grey={isEnded}>
      <Team className="team">{__('Total home')}</Team>
      <Score $grey={isEnded}>{homeScore}</Score>
      <Dash>-</Dash>
      <Score $grey={isEnded}>{awayScore}</Score>
      <Team className="team">{__('Total away')}</Team>
    </Wrapper>
  );
};

export default ScoreboardMultimatch;
